// extracted by mini-css-extract-plugin
export default {"hero__img":"Carousel_hero__img__ahxA8"};